export const learnPageBtnsList = [
	{ name: 'all' },
	{ name: 'marketing' },
	{ name: 'crypto news' },
	{ name: 'bitcoin' },
	{ name: 'trading' },
	{ name: 'research' },
	{ name: 'metaverse' },
	{ name: 'ethereum' },
	{ name: 'nft' },
];
